import { useCallback, useEffect, useState } from "react";

import { useRouteContext } from "./shared/route-context";

// NOTE: Update the time every 18s (length of screen animation)
const REFRESH_INTERVAL_MS = 18000;

export function useCurrentTime(): string {
	const { getNowDate } = useRouteContext();

	const getCurrentTime = useCallback(
		() => formatTime(getNowDate()),
		[getNowDate],
	);

	const [currentTime, setCurrentTime] = useState(getCurrentTime());

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentTime(getCurrentTime());
		}, REFRESH_INTERVAL_MS);
		return () => {
			clearInterval(interval);
		};
	}, [getCurrentTime]);

	return currentTime;
}

function formatTime(date: Date): string {
	return date.toLocaleTimeString("en-AU", {
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	});
}
